/* globals Store */
import 'chart.js'
import { mapState } from "vuex";
// import 'chart.js'
import {Bar} from 'vue-chartjs'

export default Bar.extend({
  props: ['query'],
  computed: {
    ...mapState("dashboard", {
      perdays: "perdays",
    }),
  },
  watch: {
    perdays() {
      let data = [];
      let labels = [];
      Object.keys(this.perdays.perdays).forEach(item => {
        data.push(this.perdays.perdays[item].count);
        labels.push(this.perdays.perdays[item].day);
      });

    this.renderChart({
      labels: labels,
      datasets: [
        {
          label: "Кол-во проверок",
          backgroundColor: '#f87979',
          data: data
        }
      ]
    }, {responsive: true, maintainAspectRatio: false})

    }
  },
  mounted () {
//    const query = this.query;
//    Store.dispatch("dashboard/getPerdaysLineChart", query);
  }
})



// WEBPACK FOOTER //
// ./src/components/chart/Bar.js